import React, { memo, useEffect } from 'react';
import WallpaperCard from '../Card/WallpaperCard/WallpaperCard';
import styles from './Wallpaper.module.less';
import Default from '../../../static/order_lack.svg';
import { useHistory } from 'react-router-dom';
import { CONTEXT } from '../../../config';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { getMinePayList } from '../../../actions/wallpaperPay';
import Loading from '../../../components/Loading/Loading';
import InfiniteScroll from 'react-infinite-scroller';

const selectMineInfo = createSelector(
  state => state.wallpaper,
  // wallpaper => wallpaper,
  info => info.mineInfo,
);

export default memo(({ node }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const mineInfo = useSelector(selectMineInfo);
  const jumpOther = () => {
    history.push(`${CONTEXT}/wallpaper/wprecommend`);
  };
  useEffect(() => {
    dispatch(
      getMinePayList({
        skip: 0,
        limit: 48,
        goodsType: 'wallpaper',
        appType: 12,
        tagId: 'paylist',
        refresh: true,
      }),
    );
  }, []);

  const loadMore = () => {
    dispatch(
      getMinePayList({
        skip: mineInfo.list.length,
        limit: 48,
        goodsType: 'wallpaper',
        appType: 12,
        tagId: 'paylist',
        refresh: true,
      }),
    );
  };

  return (
    <div className={styles.wallpaper}>
      {mineInfo.load && (
        <div>
          <Loading />
        </div>
      )}

      {!mineInfo.load && (
        <>
          {mineInfo.list.length === 0 && (
            <div className={styles.default}>
              <div>
                <img src={Default} />
              </div>
              <div className={styles.describe}>
                <span>您暂时还没有订单</span>
                <span className={styles.jump_other} onClick={jumpOther}>
                  去逛逛
                </span>
              </div>
            </div>
          )}
          {mineInfo.list.length !== 0 && (
            <InfiniteScroll
              page={1}
              loadMore={loadMore}
              hasMore={mineInfo.list.length < mineInfo.pagenation.count}
              loader={
                <div className="loader" key={0}>
                  ----------加载中----------
                </div>
              }
              initialLoad={false}
              useWindow={false}
              getScrollParent={() => node}
            >
              {mineInfo.list.map((el, index) => (
                <WallpaperCard key={index} {...el} />
              ))}
            </InfiniteScroll>
          )}
        </>
      )}
    </div>
  );
});
